import React from 'react'

import { useStoreMap, useUnit } from 'effector-react'

import Spinner from 'src/components/Spinner'

import { featuresQuery } from '../api/featuresQuery'
import { $features } from '../model/store'
import { FeatureFlag } from '../types'

interface FeatureGuardBaseProps {
  permit: FeatureFlag
}

interface RoutedFeatureGuard {
  path: string
  component: React.ReactElement
}

interface ComposedFeatureGuard {
  children: React.ReactElement
}

type FeatureGuardProps = FeatureGuardBaseProps &
  (RoutedFeatureGuard | ComposedFeatureGuard)

export function FeatureGuard({ permit, ...props }: FeatureGuardProps) {
  const loading = useUnit(featuresQuery.$pending)

  const allowed = useStoreMap({
    store: $features,
    keys: [permit],
    fn: (features, [key]) => features[key] ?? false,
  })

  const children = 'path' in props ? props.component : props.children

  if (!children)
    throw new Error(
      '[FeatureGuard]: Did not find child component. Make sure to pass children/component prop.',
    )

  if (loading) return <Spinner />
  if (allowed) return children

  return null
}
